module.exports = __webpack_public_path__ + "img/do.4ba64fb.svg";